import { Grid, Typography, Box } from "@material-ui/core";
import React from "react";
import Footer from "./footer";
import Header from "./header";
import Row from "./row/index";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  rootBox: {
    paddingTop: 20,
    paddingBottom: 15,
    opacity: 0.85,
  },
  iconWrapper: {
    position: "relative",
    cursor: "pointer",
    marginBottom: 8,
    display: "inline-block",
    "& svg": {
      fontSize: 120,
      color: "#d3d3d3",
      opacity: 0.6,
      transition: "color 0.4s ease",
    },
    "&:hover svg": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
  },
  messageText: {
    fontSize: 15,
    color: "#7a7a7a",
    fontWeight: 500,
  },
  createLink: {
    marginTop: 6,
    color: "#5c80bc",
    textDecoration: "underline",
    fontWeight: 500,
    fontSize: 14,
    cursor: "pointer",
    display: "inline-block",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
}));

function Table({ data, title, icon, url, type }) {
  const { t } = useTranslation();
  const styles = useStyles();

  const emptyMessageMap = {
    projects: t("No projects have been created yet..."),
    samples: t("No samples have been created yet..."),
  };

  const emptyMessage = emptyMessageMap[type] || t("No data found.");

  return (
    <div>
      <Header title={title} icon={icon} />
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        {Array.isArray(data) && data.length > 0 ? (
          data.map((val, key) => <Row key={key} val={val} />)
        ) : (
          <Grid item xs={12}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              className={styles.rootBox}
            >
              <Link
                to="/projects/create"
                className={styles.iconWrapper}
                aria-label="Create project"
              >
                <AddCircleOutlineIcon />
              </Link>
              <Typography
                variant="body2"
                align="center"
                className={styles.messageText}
              >
                {emptyMessage}
              </Typography>
              <Link to="/projects/create" className={styles.createLink}>
                {t("Click to create project")}
              </Link>
            </Box>
          </Grid>
        )}
      </Grid>

      <Footer url={url} />
    </div>
  );
}

export default Table;
